import React from "react";
import { Navigate } from "react-router-dom";
import { CM_ENABLED } from "./cmApi";

// Route guard for the ComplianceMinder MVP. When the build-time feature flag
// is off, every MVP route redirects away so the surface is invisible —
// mirroring the backend's COMPLIANCEMINDER_ENABLED gate.
export default function CMFlagGuard({ children }) {
  if (!CM_ENABLED) return <Navigate to="/dashboard" replace />;
  return children;
}
